import { object, string } from "yup";

export const getValidation = (initialValues: any) => {
  const validationSchema = object({
    name: string()
      .required("Organization Name can’t be blank")
      .default(""),
    description: string()
      .nullable()
      .default(""),
    contactEmail: string()
      .email()
      .trim()
      .required("Email can't be blank.")
      .nullable()
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast(initialValues)
  };
};
